"use strict";

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ensureToken = exports.deleteToken = exports.createToken = exports.getTokens = void 0;

var _path = _interopRequireDefault(require("path"));

var _ = require("..");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // requires config.headers with authorization


var getTokens = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var username, config, tokens, url;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            username = _ref.username, config = _ref.config;
            url = _path.default.join(_.apiPath, 'users', username, 'tokens');
            _context.prev = 2;
            _context.next = 5;
            return (0, _.get)({
              url: url,
              config: config
            });

          case 5:
            tokens = _context.sent;
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](2);
            tokens = null;

          case 11:
            return _context.abrupt("return", tokens);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 8]]);
  }));

  return function getTokens(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.getTokens = getTokens; // requires config.headers with authorization

var createToken = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var username, config, token, url, payload;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            username = _ref3.username, config = _ref3.config;
            url = _path.default.join(_.apiPath, 'users', username, 'tokens');
            payload = {
              'name': config.tokenid
            };
            _context2.prev = 3;
            _context2.next = 6;
            return (0, _.post)({
              url: url,
              payload: payload,
              config: config
            });

          case 6:
            token = _context2.sent;
            _context2.next = 12;
            break;

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](3);
            token = undefined;

          case 12:
            return _context2.abrupt("return", token);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 9]]);
  }));

  return function createToken(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

exports.createToken = createToken; // requires config.headers with authorization

var deleteToken = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
    var username, token, config, success, id, url;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            username = _ref5.username, token = _ref5.token, config = _ref5.config;
            id = token.id.toString();
            url = _path.default.join(_.apiPath, 'users', username, 'tokens', id);
            _context3.prev = 3;
            _context3.next = 6;
            return (0, _.del)({
              url: url,
              config: config,
              payload: {}
            });

          case 6:
            success = true;
            _context3.next = 12;
            break;

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](3);
            success = false;

          case 12:
            return _context3.abrupt("return", success);

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[3, 9]]);
  }));

  return function deleteToken(_x3) {
    return _ref6.apply(this, arguments);
  };
}(); // requires config.headers with authorization


exports.deleteToken = deleteToken;

var ensureToken = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref7) {
    var username, config, tokens, tokenMatches, _token2, token;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            username = _ref7.username, config = _ref7.config;
            _context4.next = 3;
            return getTokens({
              username: username,
              config: config
            });

          case 3:
            tokens = _context4.sent;

            if (!tokens) {
              _context4.next = 10;
              break;
            }

            tokenMatches = tokens.filter(function (_token) {
              return _token.name === config.tokenid;
            });

            if (!(tokenMatches && tokenMatches.length)) {
              _context4.next = 10;
              break;
            }

            _token2 = tokenMatches[0];
            _context4.next = 10;
            return deleteToken({
              username: username,
              token: _token2,
              config: config
            });

          case 10:
            _context4.next = 12;
            return createToken({
              username: username,
              config: config
            });

          case 12:
            token = _context4.sent;
            return _context4.abrupt("return", token);

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function ensureToken(_x4) {
    return _ref8.apply(this, arguments);
  };
}();

exports.ensureToken = ensureToken;